import { withFeatureBranch } from '../../../redux/flags';
import { default as NotificationsDropdown } from './NotificationsDropdown';
import { default as NotificationsDropdownV2 } from '../NotificationsDropdownV2';
export default withFeatureBranch({
    notifications_dropdown_uplift: NotificationsDropdownV2,
})(NotificationsDropdown);
//# sourceMappingURL=index.js.map